import { validColor } from "@/lib/color";
import type { OrgGroup } from "@/lib/types";
import OrgName from "./OrgName";

// 4단: 기타 위원장 — 작은 상자를 가로로 나열
export default function OrgEtcRow({ groups }: { groups: OrgGroup[] }) {
  if (groups.length === 0) return null;

  return (
    <div className="flex flex-wrap justify-center gap-3">
      {groups.map((g, i) => (
        <div
          key={g.no ?? i}
          className="org-card min-w-[150px] overflow-hidden rounded-lg border border-background-200"
        >
          <div
            className="px-4 py-2 text-center text-xs font-bold text-white"
            style={{ backgroundColor: validColor(g.color) ?? "oklch(var(--primary-700))" }}
          >
            {g.name}
          </div>
          <div className="space-y-1 bg-background-50 px-4 py-2.5 text-center text-sm font-semibold text-foreground-800">
            {g.members?.map((m, mi) => (
              <div key={m.no ?? mi}>
                <OrgName member={m} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}